<template>
  <div class="box_background shense">
    <div class="vertical_level">
      <div class="vertical_level_size">
        <img :src="logo" alt/>
      </div>
		  <div class="Icons_selection_boxes Icons_selection_item">
        <img src="./images/user.png" alt class="icon_flev"/>
        <input type="text" class="a1" name="uc" v-model="loginForm.uc" placeholder="请输入用户名" maxlength="30" @keyup.enter="login()"/>
		  </div>
		  <div class="Icons_selection_boxes_two Icons_selection_item">
        <img src="./images/possword.png" alt class="icon_flev"/>
        <input :type="showPassword?'text':'password'" class="a1" name="pwd" v-model="loginForm.pwd" placeholder="请输入密码" maxlength="30" @keyup.enter="login()"/>
        <i class="iconfont show_password" :class="showPassword?'iconkejian':'iconbukejian'" @click="showPassword=!showPassword"></i>
		  </div>
		  <!-- <div class="Icons_selection_boxes_two Icons_selection_item" v-if="!isVdnId">
        <img src="./images/vdn.png" alt class="icon_flev"/>
        <input type="text" class="a1" v-model="loginForm.vdnId" placeholder="请输入VDN" maxlength="15" @keyup.enter="login()"/>
		  </div> -->
		  <div class="sign_in" @click="login">
        <button class="login_btn">登录</button>
      </div>
      <div class="text-center font-18" style="color: #888;">
        其他登录方式 <a class="blue cur-p" style="text-decoration: underline;" @click="loginDD">守正统一登录</a>
      </div>
    </div>
  </div>
</template>

<script>
  import {getPublicKey, login} from "../../http/login";
  export default {
    data() {
      return {
        isgetUrlKey: false,
        webTimePaw: '',
        loginForm: {
          uc: "",
          pwd: "",
		      vdnId: "1",
        },
        isShowKaptcha: false,
        isVdnId: false,
        showPassword: false,
        logo: ''
      };
    },
    created() {
      if(this.$route.query.vdnId){
        this.loginForm.vdnId = this.$route.query.vdnId
        this.isVdnId = true
      }

      let path = '';
      if(window.projectConfig && window.projectConfig.logoPathName){
        path = '_' + window.projectConfig.logoPathName;
      }
      this.logo = 'static/images'+ path +'/logo-login.png';
    },
    mounted() {
    },
    methods: {
      // 写点击事件的方法
      async login() {
        // 判断用户名和密码是否为空
        if (this.loginForm.uc === "") {
          this.$Msg.error("账号不能为空");
        } else if (this.loginForm.pwd === "") {
          this.$Msg.error("密码不能为空");
        }else if (this.loginForm.vdnId == '') {
          this.$Msg.error("vdnId不能为空");
        } else {
          if(!this.isgetUrlKey){
            const res = await this.loginBefore();
            if(res.retCode == 1){
                if(res.data.publicKey && res.data.time){
                  this.isgetUrlKey = true;//如果有密匙才加密
                  LocalStorage.setItem('getPublicKey',res.data.publicKey)//存缓存，防止刷新后stroe丢失
                  this.$store.commit('navTabs/setActivePublicKey', res.data.publicKey);
                  this.webTimePaw = res.data.time - parseInt(new Date().getTime()/1000);
                }
            }
          }
          if(this.isgetUrlKey){
            let time_s = parseInt(new Date().getTime()/1000) + this.webTimePaw;
            let obj = {
              uc: this.loginForm.uc,
              pwd: this.$encryptedData(this.$store.state.navTabs.publicKey,this.loginForm.pwd + '|' + time_s),
              vdnId: this.loginForm.vdnId,
            }
            login(obj).then(res => {
              console.log(res);
              if (res && res.retCode == 100) {
                let userObj = {
                  userId: res.data.userId,
                  userName: res.data.userName,
                  workNo: res.data.userCode,
                  vdnId: res.data.vdnId || this.loginForm.vdnId,
                  authToken: res.data.authToken,
                  isSystem: res.data.isSystem
                };
                LocalStorage.setItem("obj", JSON.stringify(userObj));
                if (res.data.authToken) {
                  let Lang = '';
                  if(window.location.href.indexOf('?') > -1){
                    Lang = window.location.href.split('?')[1];
                  }
                  this.$router.push("/Index" + '?' + Lang);
                  this.$Msg.success('登录成功');
                }
              }
            });
          }
        }
      },
      loginBefore() {
        return new Promise((resolve, reject) => {
          let data = {
            vdnId: this.loginForm.vdnId
          }
          getPublicKey(data).then(res => {
            resolve(res)
          })
        })
      },
      loginDD(){
        window.location.href = window.projectConfig.LDAP;
      },
    },
  };
</script>


<style scoped>
  .box_background {
    width: 100%;
    height: 100%;
    background: url("./images/login_bg.jpg");
    background-size: cover;
    background-position: center;
  }

  .vertical_level {
    width: 300px;
    position: absolute;
    left: 77%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .a1 {
    margin-left: 12px;
    border-width: 0;
    width: 82%;
    height: 23px;
    outline: none;
    background: #fff !important;
    color: #353A42;
  }
  .a2 {
    margin-left: 12px;
    border-width: 0;
    width: 50%;
    height: 23px;
    outline: none;
    background: #fff !important;
    color: #353A42;
  }
  .i1 {
    width: 80px;
    height: 33px;
    background: #fff !important;
  }

  .vertical_level_size {
    max-width: 200px;
    margin: 0 auto;
  }

  .vertical_level_size img {
    width: 100%;
    height: 100%;
  }

  .Icons_selection_boxes {
    width: 245px;
    height: 33px;
    margin: 20px auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Icons_selection_boxes_two {
    width: 245px;
    height: 33px;
    margin: 15px auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Icons_selection_item input::-webkit-input-placeholder {
    color: #989DAA;
  }

  .Icons_selection_item {
    border: 1px solid #8E96AB52;
    border-radius: 4px;
    background: #fff;
  }

  .Icons_selection_item:hover {
    border-color: #ddd;
  }

  .sign_in {
    border-radius: 4px;
    background: #5588ff;
    width: 247px;
    height: 35px;
    margin: 21px auto 15px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .login_btn {
    background: transparent;
    border-width: 0;
    outline: none;
    font-size: 17px;
    color: white;
    display: inline-block;
    width: 100%;
    cursor: pointer;
  }

  .sign_in:hover {
    background: #1e8cff;
  }

  .icon_flev {
    width: 23px;
    height: 23px;
  }
  .show_password{
    font-size: 23px;
    cursor: pointer;
    color: #58f;
    padding: 5px;
    position: absolute;
    right: 27px;
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// login.vue?fcbfcac8